<template>
  <div class="status-zip-notification-page">
    <h5>What describes you best ?</h5>
    <RadioGroup v-model="status" class="status-selector" vertical>
      <Radio
        class="status"
        v-for="(story, i) in sortedStories"
        :key="i"
        :label="story.id"
      >{{ story.title }}</Radio>
      <Radio class="status" :label="-1">Other</Radio>
    </RadioGroup>
    <p class="input-wrapper">Let's find resources in your area:</p>
    <div style="justify-content: center;" class="input-wrapper">
      <Input style="width: 60%;" size="large" v-model="zipcode" placeholder="Enter zipcode" />
    </div>
    <PushNotificationToggle style="margin-top: 20px;" :isOnboarding="true" />
    <div
      v-if="skipPersonalInfoVerificationPage"
      style="justify-content: space-between; padding: 20px 0 20px 0px;"
      class="input-wrapper"
    >
      <p>Keep my profile private</p>
      <i-switch :disabled="isSaving" v-model="isProfilePrivate" style="float:right" />
    </div>
    <div class="input-wrapper">
      <Button
        :loading="isSaving"
        :disabled="isSaving"
        @click="save"
        style="margin-top: 10px;"
        long
        size="large"
        type="primary"
      >Submit</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueCookie from "vue-cookie";
import PushNotificationToggle from "@/components/PushNotificationEnabler";
import _ from "lodash";
import { Message } from "iview";

export default {
  name: "StatusZipNotificationPage",
  data() {
    return {
      zipcode: "",
      status: "",
      isSaving: false,
      is_public: 0
    };
  },
  components: {
    PushNotificationToggle
  },
  computed: {
    ...mapGetters("packages", ["getPackage"]),
    ...mapGetters("brand", ["getPackageStories"]),
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    skipPersonalInfoVerificationPage() {
      return this.$route.query.hasOwnProperty("skip_user_info_verification")
        ? this.$route.query.skip_user_info_verification == "true"
          ? true
          : false
        : false;
    },
    isProfilePrivate: {
      get() {
        return this.is_public == 0 ? true : false;
      },
      set(v) {
        this.is_public = !v;
      }
    },
    userStoryIds() {
      return this.getPackage.data.user_story;
    },
    stories() {
      return this.$store.state.packages.stories.filter(e => e !== null);
    },
    sortedStories() {
      let sortedStories = [];

      this.userStoryIds.forEach(e => {
        let index = this.stories.findIndex(s => s.id === e);

        if (index >= 0) {
          sortedStories.push(this.stories[index]);
        }
      });

      return sortedStories;
    },
    defaultUserStoryId() {
      return this.getPackage.data.default_story_id;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.status =
        this.getPackageStories.length > 0
          ? this.getPackageStories[0].id
          : this.defaultUserStoryId;
      this.zipcode = this.userInfo.zipcode;
      this.is_public = this.userInfo.is_public == 0 ? true : false;
    },
    validate() {
      if (this.zipcode) {
        let isValid = RegExp("^[0-9]{4,6}$").test(this.zipcode);
        if (!isValid) Message.warning("Invalid zipcode");
        return isValid;
      }

      if (!this.status) {
        Message.warning("Please select a user story");
        return false;
      }

      return true;
    },
    async save() {
      if (!this.validate()) return;
      try {
        this.isSaving = true;
        this.status = this.status == -1 ? this.defaultUserStoryId : this.status;

        if (
          this.getPackageStories &&
          this.getPackageStories.length > 0 &&
          this.getPackageStories[0].id !== this.status
        ) {
          await this.$store.dispatch(
            "user/unfollowGroup",
            this.getPackageStories[0].id
          );
        }
        await this.$store.dispatch("user/followGroups", {
          ids: this.status
        });

        let userInfo = await this.$store.dispatch("user/saveOnboardingData", {
          data: {
            id: this.userInfo.id,
            zipcode: this.zipcode,
            is_public: this.isProfilePrivate
          }
        });

        // this.$store.dispatch('user/setUserSetup', userInfo)

        //fetch selected user story for ios app caching
        await this.$store.dispatch("brand/getBrandStories", this.brandInfo.id);

        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "complete_profile"
          },
          { root: 1 }
        );
      } catch (error) {
        console.log("Unable to save onboarding data", error);
      } finally {
        this.isSaving = false;
        this.nextPage();
      }
    },
    nextPage() {
      this.$emit("nextPage");
    }
  }
};
</script>

<style lang="scss" scoped>
.status {
  font-size: 2vh;
  margin-top: 8px;
  margin-left: 10px;
}
.status-selector {
  margin: 10px;
}
</style>

<style lang="scss">
.status-zip-notification-page {
  .input-wrapper {
    input {
      text-align: center;
    }
  }
}
</style>